import React, { useEffect, useState } from "react";
import { Input, Checkbox, Button, Space, Row, Col, List, Modal, Image, Alert, Tooltip } from "antd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// import { PropertyHandlers } from "../state/actions";
import axios from "axios";
import { Loading } from "../../Common";
import { useMediaQuery } from "react-responsive";
import moment from "moment";
import ResureSign from "../../Assets/Icons/Resure_icon.png";
import { FileTextOutlined } from "@ant-design/icons";
import { transactionLaneDataHandle } from "../state/actions";
import styles from "../style/RtdWindow.module.css"
import { contractDataHandle } from "../../CreateOffer/state/actions";
import OtherDocsTable from "./OtherDocsTable";
const ReSureSignDocs = ({handleCancel,checkedDocs, setCheckedDocs, nestedModalOpen, setNestedModalOpen, propertyId, offerId, RTDInitiator, buyerAgentIds, sellerAgentIds, isWeb, delegate ,userAuthKey}) => {
  const dispatch = useDispatch();
  let { resure_Sign_Loading, resure_Sign_Docs ,importResureSignSucess} = useSelector((state) => state.rtdTransactionLane, shallowEqual);
  

  const verySmallScreen = useMediaQuery({ maxWidth: 420 });
  const isSmallScreen = useMediaQuery({ minWidth: 421,  maxWidth: 600 });
  const isMediumScreen = useMediaQuery({ maxWidth: 900, minWidth: 601 });

  let unmounted = {
    value: false,
  };
  let source = axios.CancelToken.source();


  useEffect(() => {
    dispatch(transactionLaneDataHandle.getResure_SignDocs(userAuthKey));
    return () => {
      unmounted.value = true;
      source.cancel("Cancelling in cleanup");
    };
  }, []);

 

  const handleImport = ({origin}) => {
    Modal.confirm({
      title: `Are you sure you want to add the selected ${origin === 'PROPERTY_DOCS_RE_SURE_SIGN' ? 'RE-Sure Sign' :'listing'} documents to the Property Docs folder of this offer?`,
      content: "Note: Shared copies will remain independent of the original documents.",
      okText: "Yes",
      cancelText: "No",
      onOk:() => {
        const formIds = checkedDocs.map((doc) => doc._id);
        const importPayload = {
          formIds,
          ...(offerId ? { offerId } : {}),
          ...(propertyId ? { propertyId } : {}),
          RTDInitiator,
          ...(buyerAgentIds && buyerAgentIds.length > 0 ? { buyerAgentIds } : {}),
          ...(sellerAgentIds && sellerAgentIds.length > 0 ? { sellerAgentIds } : {})
        };

       dispatch(transactionLaneDataHandle.importRe_sure_sign_docs(importPayload,userAuthKey));
        handleCancel();
        const params = {
          ...(offerId ? { offerId: offerId } : {}),
          ...(propertyId ? { propertyId: propertyId } : {}),
          openFor:  "SELLER_AGENT",
          ...(delegate ? delegate : {}),
          section: "PROPERTY_DOCS",
          ...(isWeb ? { isWeb: true } : {}),
        };
        
        // if ((offerId || propertyId)) {
        //   dispatch(contractDataHandle.getPropertyDocsFun({ params, unmounted, source,contractAuthKey:userAuthKey }));
        // }
        // Your import logic here
      },
    });
  };

  

  const handleSingleCheck = (isChecked, doc) => {
    if (isChecked) {
      // Add full doc object if not already in checkedDocs
      setCheckedDocs((prev) => {
        const exists = prev.some((d) => d._id === doc._id);
        if (!exists) {
          return [...prev, doc];
        }
        return prev;
      });
    } else {
      // Remove the doc from checkedDocs
      setCheckedDocs((prev) => prev.filter((d) => d._id !== doc._id));
    }
  };

  const isChecked = (doc) => {
    return checkedDocs.some((d) => d._id === doc._id);
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
      <div id="showMsgDiv" style={{ textAlign: "left" }}>
        <Alert style={{ width: "100%", fontSize: (isSmallScreen || verySmallScreen) ? '10px' : '12px' }} message={" When importing documents, a new copy of the selected documents will be created. This copy will be visible under Property Documents and in RE-Sure Sign Documents. When accessing from RE-Sure the imported file will be in PDF format. To send or edit the document, the document author must log in to their RE-Sure Sign account and perform these actions from there."} type="info" showIcon />
      </div>
      {resure_Sign_Loading ? ( <div style={{display: 'flex', justifyContent: "center", alignItems: 'center', height: '20vh'}}><Loading /></div>
        
      ) : (
//         <div  style={{
//                 width: "100%",
//                 color: "black",
//                 height: "300px",
//                 overflowY: "auto",
//                 marginTop:"10px",
//                 overflowX: "hidden",
//                 paddingRight: "5px",
//               }}>
//   <table className={styles.licenseTable}  style={{ width: "100%", borderTop: 0 }}>
//     <thead style={{ position: "sticky", top: 0, zIndex: 1, background: "white" }}>
//       <tr>
//         <th style={{ width: "65%" }}>Document Name</th>
//         <th style={{ width: "20%" }}>Creation Date</th>
//         <th style={{ width: "15%" }}></th>
//       </tr>
//     </thead>
//     <tbody>
//       {resure_Sign_Docs?.map((doc, index) => (
//         <tr key={index}>
//           {/* Document Name */}
//           <td style={{
//             fontWeight: "bold",
//             color: "grey",
//             fontSize: "16px",
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             maxWidth: "400px",
//             // border: "none",
//             textAlign: "left",
//           }}>
//             <div style={{display: "flex", alignItems: "center", gap: 5}}>

//               <FileTextOutlined
//                 style={{
//                   color: "#74b3ed",
//                   marginRight: "5px",
//                   fontSize: "16px",
//                 }}
//               />
//               <Tooltip title="RE-Sure Sign Document">
//               <Image
//                 style={{
//                   objectFit: "contain",
//                   height: "40px",
//                   verticalAlign: "middle",
//                 }}
//                 height={40}
//                 src={ResureSign}
//                 preview={false}
//               />
//               </Tooltip>
//               {doc.formName}
//             </div>
//           </td>

//           {/* Creation Date */}
//           <td style={{
//             color: "black",
//             fontWeight: "500",
//             textAlign: "center",
//             verticalAlign: "middle",
//             // border: "none",
//             fontSize: "12px",
//           }}>
//             {moment(doc.createdAt).format("MM/DD/YYYY")}<br />
//             {moment(doc.createdAt).format("hh:mm A")}
//           </td>

//           {/* Checkbox */}
//           <td style={{ textAlign: "center", verticalAlign: "middle",
//             //  border: "none", 
//              }}>
//             <Checkbox
//               checked={isChecked(doc)}
//               onChange={(e) => handleSingleCheck(e.target.checked, doc)}
//             />
//           </td>
//         </tr>
//       ))}
//     </tbody>
//   </table>
// </div>
// isSmallScreen ? '47vh' : isMediumScreen ? '50vh' : '53vh',
          <div>
            <div style={{ height: verySmallScreen ? "calc(52vh - 4rem)" : isSmallScreen ? "calc(52vh - 2rem)" : isMediumScreen ? "calc(52vh - 3rem)": "52vh" , overflowY: "auto" }}>
              <OtherDocsTable origin={"PROPERTY_DOCS_RE_SURE_SIGN"} reSureSignDocs={resure_Sign_Docs} handleCheckboxChange={handleSingleCheck} checkedDocs={checkedDocs} />
            </div>
            <Button size={(isSmallScreen || verySmallScreen) ? "small" : "middle"} type="primary" onClick={() => handleImport({ origin: 'PROPERTY_DOCS_RE_SURE_SIGN' })} style={{ marginTop: "20px" }} disabled={checkedDocs.length === 0}>
              Done
            </Button>
          </div>
      )}

      {/* Buttons */}
      {/* {(!resure_Sign_Loading && resure_Sign_Docs?.length > 0) && <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
        <Space>
          <Button type="primary" onClick={handleImport} disabled={checkedDocs.length === 0}>
            Import
          </Button>
          <Button onClick={handleCancel}>Cancel</Button>
        </Space>
      </div>} */}
    </div>
  );
};

export default ReSureSignDocs ;
